import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useAuth0 } from "@auth0/auth0-react";
import ai from "../../helpers/axios";
import SwitchInput from "../reusable-modules/switch-input";

const FeaturedOneWayConfigContent = () => {
  const { getAccessTokenSilently } = useAuth0();

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [enabled, setEnabled] = useState(true);
  const [originalEnabled, setOriginalEnabled] = useState(true);

  // Fetch config on mount
  useEffect(() => {
    document.title = "Featured One-Way Config | evoJets HQ";
    fetchConfig();
  }, []);

  const fetchConfig = async () => {
    try {
      setLoading(true);
      const token = await getAccessTokenSilently();
      const response = await ai
        .auth(token)
        .get("/api/featured-one-way-config/");

      if (response.data.success && response.data.data) {
        setEnabled(response.data.data.enabled);
        setOriginalEnabled(response.data.data.enabled);
      }
    } catch (error) {
      console.error("Error fetching FOW config:", error);
      toast.error("Failed to load Featured One-Way configuration");
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      const token = await getAccessTokenSilently();
      const response = await ai
        .auth(token)
        .put("/api/featured-one-way-config/", { enabled });

      if (response.data.success) {
        setOriginalEnabled(enabled);
        toast.success("Featured One-Way configuration saved successfully");
      } else {
        toast.error("Failed to save configuration");
      }
    } catch (error) {
      console.error("Error saving FOW config:", error);
      toast.error("Failed to save Featured One-Way configuration");
    } finally {
      setSaving(false);
    }
  };

  const isDirty = enabled !== originalEnabled;

  if (loading) {
    return (
      <div className="container">
        <h1>Featured One-Way Configuration</h1>
        <div className="loading-spinner">Loading...</div>
      </div>
    );
  }

  return (
    <div className="container">
      <h1 style={{ paddingTop: "20px", textAlign: "center" }}>
        Featured One-Way Configuration
      </h1>

      <div className="card mt-20">
        <div className="card-body" style={{ textAlign: "center" }}>
          <h3>FOW Visibility</h3>
          <p className="text-muted mb-20">
            Control whether FOW flights are visible in the iOS app. When
            disabled, the app will not display any FOW options.
          </p>

          <div className="form-group">
            <SwitchInput
              checked={enabled}
              onChange={(e) => setEnabled(e.target.checked)}
              leftLabel="Disabled"
              rightLabel="Enabled"
            />
          </div>

          <div className="mt-20">
            <button
              className="btn btn-primary"
              onClick={handleSave}
              disabled={saving || !isDirty}
            >
              {saving ? "Saving..." : "Save Changes"}
            </button>

            {isDirty && (
              <div style={{ color: "red", marginTop: "10px" }}>
                You have unsaved changes
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturedOneWayConfigContent;
